import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { shareReplay, tap } from 'rxjs/operators';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';
import { environment } from 'src/environments/environment';
import { IEnvironment } from 'src/app/shared/models/environment-interface/i-environment';


interface IConfiguration {
  restApiUrl: string;
}
@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  private readonly CONFIG_URL = 'assets/config/config.json.php';
  private configuration$: Observable<IEnvironment>;

  constructor(
    private http: HttpClient,
    private environmentResolveService: EnvironmentResolveService) { }

  loadConfiguration(): any {

    if(!this.configuration$ && environment.production) {
      this.configuration$ = this.http.get<IEnvironment>(this.CONFIG_URL)
        .pipe(
          shareReplay(1)
        );
    } else {
      this.configuration$ = of(environment as IEnvironment);
    }
    this.environmentResolveService.setEnvironment(this.configuration$);
    return this.configuration$;
  }

  getApiUrl(): Observable<any>{
    return this.configuration$;
  }
}
